import AddOnImpl from 'live/api/add-on'
import locale from 'live/init/global-locale'
import i18n from 'live/services/i18n'
import liveUiService from 'live/services/ui'
import { Component } from 'react'
import { enUS, ptBR } from './i18n'
import { LinkDashboardModal } from './components/LinkDashboardModal'
import { DashboardMenuLinks } from './components/DashboardMenuLinks'

const localeFiles = {
    pt_br: ptBR,
    en_us: enUS
}

i18n.add(localeFiles[locale])

try {
    liveUiService.registerAddOn(
        liveUiService.uiSections.DASHBOARD_EDITION_MAIN_HEADER,
        new AddOnImpl((LinkDashboardModal as unknown) as Component, { order: 9 })
    )

    liveUiService.registerAddOn(
        liveUiService.uiSections.DASHBOARD_VIEW_UNDER_HEADER,
        new AddOnImpl((DashboardMenuLinks as unknown) as Component, { order: 0 })
    )
} catch (e) {
    console.error(e)
}
